<script setup lang="ts">
import { ref } from 'vue'
import { FileUp, ShieldCheck } from '@lucide/vue'
import { SUPPORTED_FORMATS } from '../app/constants'

const emit = defineEmits<{
  select: [file: File]
}>()

const inputRef = ref<HTMLInputElement>()
const isDragging = ref(false)

function openPicker() {
  inputRef.value?.click()
}

function onInput(event: Event) {
  const target = event.target as HTMLInputElement
  const file = target.files?.[0]
  if (file) {
    emit('select', file)
  }
  target.value = ''
}

function onDrop(event: DragEvent) {
  isDragging.value = false
  const file = event.dataTransfer?.files?.[0]
  if (file) {
    emit('select', file)
  }
}
</script>

<template>
  <section
    class="drop-zone"
    :class="{ dragging: isDragging }"
    aria-labelledby="file-entry-title"
    @dragover.prevent="isDragging = true"
    @dragleave.prevent="isDragging = false"
    @drop.prevent="onDrop"
  >
    <div class="privacy-chip">
      <ShieldCheck :size="16" aria-hidden="true" />
      文件只在本机处理
    </div>
    <h1 id="file-entry-title">打开就能看，需要时再改</h1>
    <p class="lead">
      Word 和 Markdown 支持目录阅读，PDF 本地打开，Excel 与 CSV 可筛选排序，HTML 使用安全预览，JSON 与 Lottie 可直接查看。
    </p>

    <div class="file-action-stack">
      <button class="primary-action" type="button" @click="openPicker">
        <FileUp :size="22" aria-hidden="true" />
        选择文件
      </button>
      <small>安装为手机应用后，可从文件管理器选择“用轻阅档打开”</small>
    </div>
    <input
      ref="inputRef"
      class="sr-only"
      type="file"
      :accept="SUPPORTED_FORMATS.flatMap((format) => format.extensions).join(',')"
      @change="onInput"
    />

    <ul class="format-grid" aria-label="支持格式">
      <li v-for="format in SUPPORTED_FORMATS" :key="format.kind">
        <strong>{{ format.label }}</strong>
        <span>{{ format.extensions.join(' / ') }}</span>
      </li>
    </ul>
  </section>
</template>
